// src/pages/Login.jsx
import axios from "axios";
import localforage from "localforage";
import { useState } from "react";
import { Container, Grid, TextField, Button, Typography, Box } from "@mui/material";

import global from "../utils/global";
import { ModalLoad, ModalErro } from "../components/models/models";

export default function Login() {
  const [userEmail, setUserEmail] = useState("");
  const [userSenha, setUserSenha] = useState("");

  // modal load
  const [showModalLoad, setShowModalLoad] = useState(false);

  // modal erro
  const [showModalErro, setShowModalErro] = useState(false);
  const [msgModalErro, setMsgModalErro] = useState("");
  const [funcPosModalErro, setFuncPosModalErro] = useState(() => () => {});

  const logar = () => {
    if (!userEmail) {
      setMsgModalErro("Preencha o campo de login!");
      setShowModalErro(true);
      return;
    }

    if (!userSenha) {
      setMsgModalErro("Preencha o campo de senha!");
      setShowModalErro(true);
      return;
    }

    setShowModalLoad(true);

    axios
      .post(global.baseUrl + "/AuthApi/LoginFuncionario", {
        login: userEmail,
        senha: userSenha,
      })
      .then((response) => {
        if (response.data.code === 0) {
          let user = response.data.content;
          localforage.setItem("user", user).then(() => {
            window.location.href = "/";
          });
        } else {
          setMsgModalErro("Erro ao efetuar login: " + response.data.msg);
          setShowModalErro(true);
        }
      })
      .catch((ex) => {
        console.error("erro: ", ex);
        setMsgModalErro("Erro ao efetuar login!");
        setShowModalErro(true);
      })
      .finally(() => setShowModalLoad(false));
  };

  return (
    <Container maxWidth="sm">
      <ModalErro
        showModal={showModalErro}
        setShowModal={setShowModalErro}
        msg={msgModalErro}
        funcPos={funcPosModalErro}
      />
      <ModalLoad showModal={showModalLoad} />

      <Box mt={4} mb={4}>
        <Typography variant="h4" align="center">
          Login Etiqueta
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <TextField
        fullWidth
        label="E-mail"
        variant="outlined"
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value)}
        />

        <TextField
        fullWidth
        label="Senha"
        type="password"
        variant="outlined"
        value={userSenha}
        onChange={(e) => setUserSenha(e.target.value)}
        />

        <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={logar}
        >
            Login
        </Button>
      </Grid>
    </Container>
  );
}
